import { lazy } from 'solid-js'
import { messages } from '../../pages/verto-checkout-page/verto-checkout-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/verto-checkout-page/verto-checkout-page.jsx')),
    lockCurrencySelection: true,
    path: '/checkout/:booking_id/payment/verto',
    showFooter: false,
    showHeaderMenu: false,
    showUserHeader: true,
    titleMessage: messages.titleMessage,
}
